import * as Browser from 'bowser';

const browser = Browser.getParser(window.navigator.userAgent);
const browserName = browser.getBrowserName();

const supportedBrowser = () =>
    browserName === 'Chrome' || browserName === 'Microsoft Edge' || browserName === 'Safari';

// Toggle features depending on environment variables
export const FeatureToggling = {
    supportedBrowser: supportedBrowser(),
};
